import { render } from "./Basketball.vue?vue&type=template&id=4910b773&scoped=true&ts=true"
import script from "./Basketball.vue?vue&type=script&setup=true&lang=ts"
export * from "./Basketball.vue?vue&type=script&setup=true&lang=ts"

import "./Basketball.vue?vue&type=style&index=0&id=4910b773&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4910b773"],['__file',"src/components/player/Basketball.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4910b773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4910b773', __exports__)) {
    console.log('reload')
    api.reload('4910b773', __exports__)
  }
  
  module.hot.accept("./Basketball.vue?vue&type=template&id=4910b773&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4910b773', render)
  })

}


export default __exports__